<loading [loading]="loading.isShow" [loadingMessage]="loading.message"></loading>
<div [hidden]="loading.isShow">
  <ng-container *ngIf="error_messages.length > 0">
    <ng-container *ngFor="let error_message of error_messages">
      <div class="alert alert-danger">
        <button type="button" class="close" data-dismiss="alert" (click)="removeErrorMessage(error_message)">
          ×
        </button>
        {{ error_message }}
      </div>
    </ng-container>
  </ng-container>

  <div [hidden]="!login">
    <div class="loginmodal-container">
      <h1>Log in to your signNow account</h1>
      <br />
      <form>
        <input type="text" name="user" class="sn-sf-input" placeholder="Email" #emailInput />
        <input type="password" name="pass" class="sn-sf-input" placeholder="Password" #passwordInput />
        <div class="loginmodal-container__controls">
          <button
            class="btn btn-primary full-width"
            (click)="login_user(emailInput.value, passwordInput.value)"
          >
            Login
          </button>
          <sn-sso-login-btn (loginEvent)="reloadAfterSSOLogin()"></sn-sso-login-btn>
          <div class="tac create-account">
            <span>No account?&nbsp;</span>
            <a
              class="create-account__link"
              href="https://snseats.signnow.com/purchase/business_free_trial/loggedout?source=salesforce"
              target="_blank"
            >
              Sign up for signNow for free
            </a>
          </div>
        </div>
      </form>
    </div>
  </div>

  <div [hidden]="login">
    <button class="btn btn-primary log-out-btn" (click)="logout_user()">Logout</button>

    <section
      role="dialog"
      tabindex="-1"
      class="slds-modal_large"
      aria-labelledby="id-of-modalheader-h2"
      aria-describedby="modal-content-id-1"
    >
      <div class="slds-modal__container">
        <header class="slds-modal__header">
          <h2 id="id-of-modalheader-h2" class="slds-text-heading_medium">Attachments</h2>
        </header>
        <div class="slds-modal__content slds-p-around_medium" id="modal-content-id-1">
          <div class="row">
            <div class="col-md attachments-container">
              <div class="panel panel-default panel-table">
                <div class="panel-heading">
                  <div class="row">
                    <div class="col">
                      <input
                        type="text"
                        (keyup)="search_attachments(search.value)"
                        class="sn-sf-input"
                        id="search"
                        placeholder="Search the Attachments of this Record"
                        #search
                      />
                      <span class="glyphicon glyphicon-search search-icon"></span>
                    </div>
                  </div>
                </div>
                <div class="panel-body">
                  <div class="scrolling">
                    <table class="table table-bordered table-list" id="AttachmentTable" #AttachmentTable>
                      <tbody>
                        <ng-container *ngFor="let attachment of attachments">
                          <tr>
                            <td>
                              <a (click)="send_attachment_to_signnow(attachment)" href="javascript:void(0);">
                                <span class="glyphicon glyphicon-file"></span>&nbsp;&nbsp;{{
                                  attachment.Name
                                }}
                              </a>
                            </td>
                            <td class="created_column">Created On: {{ attachment.CreatedDate }}</td>
                          </tr>
                        </ng-container>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</div>
